<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="22"
    height="14"
    viewBox="0 0 22 14"
    fill="none"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M21.5 6.99899C21.5 6.80008 21.421 6.60932 21.2803 6.46866C21.1397 6.32801 20.9489 6.24899 20.75 6.24899H3.0605L7.781 1.52999C7.85073 1.46026 7.90604 1.37748 7.94378 1.28637C7.98152 1.19526 8.00095 1.09761 8.00095 0.998994C8.00095 0.900378 7.98152 0.802728 7.94378 0.711619C7.90604 0.62051 7.85073 0.537726 7.781 0.467994C7.71127 0.398262 7.62848 0.342948 7.53737 0.305209C7.44626 0.267471 7.34861 0.248047 7.25 0.248047C7.15138 0.248047 7.05373 0.267471 6.96262 0.305209C6.87151 0.342948 6.78873 0.398262 6.719 0.467994L0.718998 6.46799C0.649153 6.53766 0.593739 6.62043 0.555929 6.71154C0.518119 6.80266 0.498657 6.90034 0.498657 6.99899C0.498657 7.09764 0.518119 7.19533 0.555929 7.28644C0.593739 7.37756 0.649153 7.46033 0.718998 7.52999L6.719 13.53C6.78873 13.5997 6.87151 13.655 6.96262 13.6928C7.05373 13.7305 7.15138 13.7499 7.25 13.7499C7.34861 13.7499 7.44626 13.7305 7.53737 13.6928C7.62848 13.655 7.71127 13.5997 7.781 13.53C7.85073 13.4603 7.90604 13.3775 7.94378 13.2864C7.98152 13.1953 8.00095 13.0976 8.00095 12.999C8.00095 12.9004 7.98152 12.8027 7.94378 12.7116C7.90604 12.6205 7.85073 12.5377 7.781 12.468L3.0605 7.74899H20.75C20.9489 7.74899 21.1397 7.66998 21.2803 7.52932C21.421 7.38867 21.5 7.19791 21.5 6.99899Z"
      fill="#213e7a"
    />
  </svg>
</template>

<script>
export default { name: 'IconArrowBack' };
</script>

<style></style>
